import { createContext, useState, useEffect } from 'react'
import { useReadLocalStorage, useDarkMode } from 'usehooks-ts'

export const ThemeContext = createContext({
  currentTheme: 'light',
})

interface ThemeProviderProps {
  contentfulDarkModeSet?: boolean
  children: React.ReactNode
}

export const ThemeProvider = ({ contentfulDarkModeSet, children }: ThemeProviderProps) => {
  const [currentTheme, setCurrentTheme] = useState('light')
  const theme = useReadLocalStorage('theme')
  const enableDarkMode = useReadLocalStorage('bwDarkMode')
  useEffect(() => {
    const doc = document.documentElement

    // temporary dark mode for developers page until we go for full dark mode support (dark mode is from contentful landing page settings)
    contentfulDarkModeSet && doc.classList.add('dark')
    !contentfulDarkModeSet && doc.classList.remove('dark')

    // if we havent chosen a theme yet, we will use the system and add dark class if system is dark
    if (theme === null && enableDarkMode) {
      window.matchMedia('(prefers-color-scheme: dark)').matches && doc.classList.add('dark')
      setCurrentTheme(window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
    }
    // if we have chosen a theme
    if (theme === 'light' && enableDarkMode) {
      setCurrentTheme('light')
      doc.classList.remove('dark')
    }
    if (theme === 'dark' && enableDarkMode) {
      setCurrentTheme('dark')
      doc.classList.add('dark')
    }
  }, [theme])

  return <ThemeContext.Provider value={{ currentTheme }}>{children}</ThemeContext.Provider>
}
